class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onClick.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    } else {
      // Alle anderen schließen
      document.querySelectorAll('details-disclosure details[open]').forEach(d => d.removeAttribute('open'));
      this.mainDetailsToggle.setAttribute('open', '');
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
